import { EEncryptionType } from './IntegrationSettings/IntegrationSettings';

export enum EPlayersAuthenticationModel {
  PUBLISHER = 'publisher',
  APPCHARGE = 'appcharge'
}

export enum EAppleResponseType {
  CODE = 'code',
  ID_TOKEN = 'id_token'
}

export enum EPublisherEventValue {
  ORDER_CREATED = 'order_created',
  PAYMENT_INTENT_SUCCESS = 'payment_intent_success',
  PAYMENT_INTENT_FAILED = 'payment_intent_failed',
  ORDER_COMPLETED_SUCCESS = 'order_completed_success',
  ORDER_COMPLETED_FAILED = 'order_completed_failed',
  ORDER_CANCELED = 'order_canceled',
  ORDER_REFUNDED = 'order_refunded',
  ORDER_DISPUTE_OPEN = 'order_dispute_open',
  ORDER_DISPUTE_LOST = 'order_dispute_lost',
  ORDER_DISPUTE_WON = 'order_dispute_won',
  OFFERS_SHOWN = 'offers_shown',
  OFFERS_LOADED = 'offers_loaded',
  LOGIN_LAND = 'login_land',
  LOGIN_CLICKED = 'login_clicked',
  LOGIN_OTP_IOS_BUTTON = 'login_otp_ios_button',
  LOGIN_OTP_ANDROID_BUTTON = 'login_otp_android_button',
  LOGIN_CANCELED = 'login_canceled',
  LOGIN_APPROVAL = 'login_approval',
  LOGIN_RESULT = 'login_result',
  INVALID_PROPERTY_ERROR = 'invalid_property_error',
  APPROVAL_REQUEST_CLOSED = 'approval_request_closed',
  APPROVAL_REQUEST_DISPLAYED = 'approval_request_displayed',
  LOGIN_METHOD_SELECTED = 'login_method_selected',
  LOGIN_RESOLVED = 'login_resolved',
  SHOP_LAND = 'shop_land',
  WEBSTORE_PERSONALIZATION_ERROR_INVALID_PROPERTY = 'webstore.personalization_api.error.invalid_property',
  WEBSTORE_PERSONALIZATION_ERROR = 'webstore.personalization_api.error',
  WEBSTORE_OFFERS_LOADED = 'webstore.offers.loaded',
  WEBSTORE_OFFERS_DISPLAYED = 'webstore.offers.displayed',
  POPUP_CLOSED = 'webstore.offers.popup_closed',
  WEBSTORE_APPROVAL_REQUEST_DISPLAYED = 'webstore.approval_request.displayed',
  WEBSTORE_APPROVAL_REQUEST_CLOSED = 'webstore.approval_request.closed',
  WEBSTORE_LOGIN_DISPLAYED = 'webstore.login.displayed',
  WEBSTORE_STORE_DISPLAYED = 'webstore.store.displayed',
  WEBSTORE_LOGIN_METHOD_SELECTED = 'webstore.login.login_method.selected',
  WEBSTORE_LOGIN_CANCELED = 'webstore.login.canceled',
  WEBSTORE_LOGIN_COMPLETED = 'webstore.login.completed',
  WEBSTORE_PROGRESS_BAR_POINTS_GRANTED = 'webstore.offers.progress_bar.points.granted',
  WEBSTORE_PROGRESS_BAR_MISSION_COMPLETED = 'webstore.offers.progress_bar.mission.completed',
  WEBSTORE_PROGRESS_BAR_MISSION_STARTED = 'webstore.offers.progress_bar.mission.started',
  WEBSTORE_POPUP_TRIGGERED = 'webstore.offers.popup_triggered',
  WEBSTORE_BADGE_CLICKED = 'webstore.offers.badge_clicked',
  WEBSTORE_OFFER_CLICKED = 'webstore.offer.clicked',
  ORDER_ORDER_CREATED = 'order.created',
  ORDER_ORDER_PAYMENT_RESOLVED = 'order.payment.resolved',
  ORDER_ORDER_COMPLETED = 'order.completed',
  ORDER_ORDER_REFUNDED = 'order.refunded',
  ORDER_ORDER_DISPUTE_OPENED = 'order.dispute.opened',
  ORDER_ORDER_DISPUTE_RESOLVED = 'order.dispute.resolved',
  ORDER_ORDER_CANCELED = 'order.canceled',
  ORDER_REFUND_FAILED = 'order.refund.failed',
  PORTAL_LOGIN_DISPLAYED = 'portal.login.displayed',
  PORTAL_LOGIN_METHOD_SELECTED = 'portal.login.login_method.selected',
  PORTAL_LOGIN_CANCELED = 'portal.login.canceled',
  PORTAL_LOGIN_COMPLETED = 'portal.login.completed',
  PORTAL_PAGE_DISPLAYED = 'portal.page.displayed',
  PORTAL_CONTENT_DISPLAYED = 'portal.content.displayed',
  PORTAL_FOOTER_CLICKED = 'portal.footer.clicked',
  PORTAL_BLOCK_CLICKED = 'portal.block.clicked'
}

export interface ProfileData {
  _id: string;
  name: string;
  ordersReportingApiUrl: string;
  playersAuthWebhook: string;
  playerInfoSyncUrl?: string;
  eventsWebhookUrl?: string;
  fbAppId?: string;
  otpDeepLink?: {
    otpGenerateDeeplinkUrl?: string;
    otpOn?: boolean;
    otpTextModel?: string;
  };
}

export interface IntegrationSettingsData {
  _id: string;
  apiUrlPrimaryKey: string;
  apiUrlSecondaryKey: string;
  checkoutPublicKey: string;
  backToGameDeepLink: string;
  ordersReportingApiUrl: string;
  playersAuthModel: string;
  publisherToken: string;
  deeplinkOn?: Boolean;
  deeplinkJwtSecret?: string;
  isDeeplinkJwtSecretSettingsEnabled?: boolean;
  playerInfoSyncUrl: string;
  playersAuthWebhook: string;
  publisherId: string;
  usernamePasswordOn: boolean;
  facebookModel: EPlayersAuthenticationModel;
  usernamePasswordModel: EPlayersAuthenticationModel;
  deepLinkButtonOn: boolean;
  backToStoreButtonOn: boolean;
  encryptionModel: EEncryptionType;
  eventsWebhookUrl: string;
  eventsV2WebhookUrl: string;
  enabledWebhookEvents: string[];
  enabledWebhookEventsV2: string[];
  playersAuthentication: Partial<{
    appleModel: EPlayersAuthenticationModel;
    appleAppId: string;
    appleOn: boolean;
    appleAppSecret: string;
    appleResponseType: EAppleResponseType;
    googleAppSecret: string;
    googleAppId: string;
    googleModel: EPlayersAuthenticationModel;
    googleOn: boolean;
    fbAppSecret: string;
    fbAppId: string;
    fbModel: string;
    fbOn: boolean;
    userTokenOn: boolean;
    userTokenModel: string;
    userTokenText: string;
    userTokenUrl: string;
    usernamePasswordOn: boolean;
    usernamePasswordModel: string;
    otpOn: boolean;
    otpTextModel: string;
    reconnectOn: boolean;
  }>;
  deepLinks: any;
  otpGenerateDeeplinkUrl: string;
  appsFlyerIntegration: {
    appsFlyerIntegrationOn: boolean;
    appsFlyerApplicationID: string;
    appsFlyerS2SToken: string;
  };
  isProfilesEnabled?: boolean;
}

export interface PublisherEventType {
  value: EPublisherEventValue;
  displayName?: string;
  subCategory?: string;
  category?: string;
  version: 'v1' | 'v2';
}

export enum ESettingsState {
  COMPANY = 'company',
  USERS = 'users',
  INTEGRATION = 'integration',
  PROFILES = 'profiles',
  PLAYER_AUTH = 'playerAuth',
  PAYMENTS = 'payments',
  ENCRYPTION = 'encryption',
  LAYOUT = 'layout',
  EVENTS = 'events',
  STORE_SETTINGS = 'storeSettings',
  PORTAL = 'portal',
  DEVELOPER_SETTINGS = 'developerSettings',
  DEFAULT = 'default'
}

export enum ProfileField {
  ORDER_REPORTING_API = 'Grant Award Callback',
  AUTHENTICATION_WEBHOOK = 'Authentication Webhook',
  PERSONALIZATION_API_URL = 'Personalization API URL',
  EVENTS_WEBHOOK = 'Events Webhook',
  FACEBOOK_ID = 'Facebook ID',
  OTP_GENERATION_DEEPLINK_URL = 'OTP Generation Deeplink Url',
  DESKTOP_TEXT_MODEL = 'Desktop Text Model'
}

export interface ProfileFormValues {
  name: string;
  playerInfoSyncUrl: string;
  playersAuthWebhook: string;
  ordersReportingApiUrl: string;
  eventsWebhookUrl: string;
  fbAppId: string;
  otpDeepLink: {
    otpGenerateDeeplinkUrl: string;
    otpOn: boolean;
    otpTextModel: string;
  };
}
